import Joi from '@hapi/joi'

export const factoryItemValidationSchemaObject = {

    groupID: Joi.number().invalid(0).required().label("Group").messages({ "any.invalid": `Group Required`, }),
    operationEntityID: Joi.number().invalid(0).required().label("Operation Entity").messages({ "any.invalid": `Operation Entity Required`, })

}